import { useMemo } from "react";
import { FCX, SuggestedSearches as PlatformSuggestedSearches } from "@datassential/platform-ui-lib";
import cn from "classnames";
import { SuggestedSearch } from "@apiHooks/useCommonData";
import { excludeNullable, mapByKey, randomizeItems } from "@core/utils/array";

const SUGGESTED_SEARCHES_COUNT = 3;

interface SuggestedSearchesProps {
    data: SuggestedSearch[];
    onSearchClick: (search: string) => void;
}

const SuggestedSearches: FCX<SuggestedSearchesProps> = ({ data, onSearchClick }) => {
    const suggestedSearches = useMemo(
        () => randomizeItems(
            excludeNullable(mapByKey(data, 'text')),
            SUGGESTED_SEARCHES_COUNT
        ),
        [data]
    );

    if (!suggestedSearches.length) return null;

    return (
        <PlatformSuggestedSearches
            className={cn("ToolSearch__recent-searches", "ToolSearchRecentSearches")}
            searches={suggestedSearches}
            title="Suggested Questions"
            onSearchClick={onSearchClick}
        />
    );
};

export default SuggestedSearches;